module.exports = __webpack_public_path__ + "static/media/redwarning.a856c1fa.png";